import { render, staticRenderFns } from "./MyPhoto.vue?vue&type=template&id=7f7c5035&scoped=true&"
import script from "./MyPhoto.vue?vue&type=script&lang=js&"
export * from "./MyPhoto.vue?vue&type=script&lang=js&"
import style0 from "./MyPhoto.vue?vue&type=style&index=0&id=7f7c5035&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7c5035",
  null
  
)

export default component.exports